export default __webpack_public_path__ + "static/media/Screenshot_6.1aca586d.png";